var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      initData: _vm.shiftTypeData,
      checkData: [
        "shift_type_name",
        "shift_type_abbr",
        "shift_type_code",
        "shift_type_description",
        "sequence",
      ],
      backgroundClass: "white",
      title: _vm.$t("label_essweb_shiftType_form_newTitle"),
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.shiftTypeData.shift_type_name,
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_shiftType_form_typeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.shiftTypeData.shift_type_abbr,
                            label: _vm.$t(
                              "label_essweb_shiftType_form_typeAbbrLabel"
                            ),
                            maxlength: "20",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: "20",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_codeLabel"
                            ),
                          },
                          model: {
                            value: _vm.shiftTypeData.shift_type_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.shiftTypeData,
                                "shift_type_code",
                                $$v
                              )
                            },
                            expression: "shiftTypeData.shift_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: "255",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 255]
                            ),
                            label: _vm.$t(
                              "label_essweb_shiftType_form_sequenceLabel"
                            ),
                            type: "number",
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.shiftTypeData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.shiftTypeData, "sequence", $$v)
                            },
                            expression: "shiftTypeData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.shiftTypeData.shift_type_description,
                            maxlength: "500",
                            label: _vm.$t(
                              "label_essweb_shiftType_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.newShiftType,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }